import { render, staticRenderFns } from "./SurveyQuestionAnswerEditor.vue?vue&type=template&id=0a754b68&scoped=true"
import script from "./SurveyQuestionAnswerEditor.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionAnswerEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a754b68",
  null
  
)

export default component.exports